import useIsMobile from '@/hooks/useIsMobile';
import useShopLogin from './useShopLogin';
import ShopLoginDesktop from './desktop';
import ShopLoginMobile from './mobile';

function ShopLogin() {
  const isMobile = useIsMobile(992);
  const viewModel = useShopLogin();

  return isMobile ? <ShopLoginMobile viewModel={viewModel} /> : <ShopLoginDesktop viewModel={viewModel} />;
}

export default ShopLogin;
